module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "titlepage"
    }
  }, [_c('h1', {
    staticClass: "booktitle"
  }, [_vm._v("WINE BITES")]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("SIMPLE MORSELS THAT PAIR PERFECTLY WITH WINE")]), _vm._v(" "), _c('p', {
    staticClass: "byline"
  }, [_c('i', [_vm._v("by")])]), _vm._v(" "), _c('h3', {
    staticClass: "author"
  }, [_vm._v("Barbara Scott-Goodman")]), _vm._v(" "), _c('p', {
    staticClass: "othertext"
  }, [_c('i', [_vm._v("Photographs")]), _vm._v(" by Kate Mathis"), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "publogo"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "132",
      "src": "images/logo.jpg",
      "width": "300"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac32e732","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002titlepage.vue
// module id = 60
// module chunks = 0